import React from "react";
import { Link } from "react-router-dom";
import { BOOKING_URL, CHERRY_APPLY_URL } from "@/lib/site";
import { BookLink } from "@/components/site/BookLink";
import { PageHero, Eyebrow } from "@/components/site/Section";
import { CherrySection } from "@/components/site/CherrySection";
import { trackEvent } from "@/lib/analytics";

function ApplyBtn({ className, children = "Apply With Cherry", testid }) {
  return (
    <a
      href={CHERRY_APPLY_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      onClick={() => trackEvent("book_click", "Apply With Cherry")}
      className={className}
    >
      {children}
    </a>
  );
}

export default function Financing() {
  return (
    <div data-testid="financing-page">
      <PageHero
        eyebrow="Cherry Payment Plans"
        title="Financing Options"
        subtitle="Make aesthetic and wellness treatments more accessible with Cherry payment plans. Check your options without impacting your credit score."
      />

      <section className="py-8 bg-[var(--cream-2)] border-b border-[var(--line)]">
        <div className="max-w-[1100px] mx-auto px-5 lg:px-10 flex flex-wrap justify-center gap-4">
          <ApplyBtn testid="financing-apply-top" className="btn-gold rounded-md px-8 py-3.5" />
          <Link to="/contact" className="btn-outline-gold rounded-md px-8 py-3.5">Contact Us</Link>
        </div>
      </section>

      <section className="pt-14 pb-6 bg-[var(--cream)]">
        <div className="max-w-[850px] mx-auto px-5 lg:px-10 text-center">
          <Eyebrow className="mb-3">Primary Financing Option</Eyebrow>
          <h2 className="font-display text-4xl sm:text-5xl text-[var(--charcoal)]">Cherry Payment Plans</h2>
          <p className="text-[var(--charcoal-soft)] mt-4 leading-relaxed">
            Cherry is Seraphina Collective's featured financing option. Use the estimator below to explore
            payment plan examples and see if you qualify.
          </p>
        </div>
      </section>

      {/* Real Cherry widget embed */}
      <section className="pb-16 bg-[var(--cream)]">
        <CherrySection />
      </section>

      <section className="py-16 bg-[var(--cream-2)] border-y border-[var(--line)]">
        <div className="max-w-[900px] mx-auto px-5 lg:px-10">
          <div className="soft-card rounded-3xl p-10 text-center">
            <h2 className="font-display text-4xl text-[var(--charcoal)]">Ready to get started?</h2>
            <p className="text-[var(--charcoal-soft)] mt-4">
              Use Cherry to view payment plan options, then book your consultation or contact Seraphina Collective with questions.
            </p>
            <div className="flex flex-wrap justify-center gap-4 mt-7">
              <ApplyBtn testid="financing-apply-bottom" className="btn-gold rounded-md px-8 py-3.5" />
              <BookLink label="Financing Book" href={BOOKING_URL} className="btn-outline-gold rounded-md px-8 py-3.5">Book Appointment</BookLink>
            </div>
          </div>
        </div>
      </section>

      <section className="py-10 bg-[var(--cream)]">
        <p className="text-[0.72rem] text-[var(--charcoal-soft)] leading-relaxed max-w-2xl mx-auto px-5 text-center">
          These are examples only. 0% APR and other promotional rates subject to eligibility. Exact terms and APR
          depend on credit score and other factors. Payment options through Cherry Technologies, Inc. Copyright ©
          2020-{new Date().getFullYear()} Cherry Technologies Inc. NMLS #2061234.
        </p>
      </section>
    </div>
  );
}
